import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import * as S from "./styled";
import { useGlobals } from "../../context/DesignSystemGlobals";

type TProps = Pick<Dialog.DialogProps, "open" | "defaultOpen" | "onOpenChange"> &
    React.ComponentProps<typeof S.DialogContent> & {
        disablePortal?: boolean;
    };

const Modal: React.FC<TProps> = ({ open, disablePortal = false, onOpenChange, defaultOpen, children, ...props }) => {
    const globals = useGlobals();
    const Portal = disablePortal ? React.Fragment : Dialog.Portal;
    const portalProps = disablePortal ? {} : { container: document.getElementById(globals.ROOT_ID) };

    return (
        <Dialog.Root defaultOpen={defaultOpen} open={open} onOpenChange={onOpenChange}>
            <Portal {...portalProps}>
                <S.DialogOverlay />
                <S.DialogContentWrapper>
                    <S.DialogContent {...props}>{children}</S.DialogContent>
                </S.DialogContentWrapper>
            </Portal>
        </Dialog.Root>
    );
};

export default Modal;
